module.exports = __webpack_public_path__ + "media/images/docflix-green-b804182c234a1bd13ee1a7db1430b35b.png";